import React, { useState } from 'react';

import { PickerTitle } from '@entities/period-picker/model/picker-title.enum';
import { useScreenSize } from '@shared/hooks';
import { DateRangePickerCalendar, Skeleton } from '@shared/ui';

import cls from './CalendarPeriodPicker.module.css';
import { PeriodPicker } from './PeriodPicker';
import { usePeriodPicker, useDateRangePickerCalendar } from '../lib/hooks';
import { TCalendarRange } from '../model/types';

export const CalendarPeriodPicker = ({ isPending }: { isPending: boolean }) => {
    const [calendarRange, setCalendarRange] = useState<TCalendarRange>([null, null]);
    const { handleClickPicker, periodInput, handlePeriodInputChange, onChangeRangeQueryValues } =
        usePeriodPicker({
            calendarRange,
            setCalendarRange,
        });

    const { openToDate, handleCalendarChange, getMinDate, getToday } = useDateRangePickerCalendar({
        setCalendarRange,
        calendarRange,
        handlePeriodInputChange,
    });
    const { width: windowSize } = useScreenSize();

    return (
        <section className={cls.CalendarPeriodPicker}>
            <PeriodPicker
                handleClickPicker={handleClickPicker}
                periodValue={periodInput}
                onChangePeriod={handlePeriodInputChange}
                isPending={isPending}
                onChangeRangeQueryValues={onChangeRangeQueryValues}
            />
            {isPending ? (
                <Skeleton width="100%" height={166.4} border="8px" />
            ) : (
                <DateRangePickerCalendar
                    maxDate={getToday()}
                    minDate={getMinDate()}
                    openToDate={openToDate}
                    value={calendarRange}
                    onChange={(range) => {
                        handleClickPicker(PickerTitle.CHOOSE_PERIOD);
                        handleCalendarChange(range);
                    }}
                    monthsShown={windowSize <= 1500 ? 1 : 2}
                />
            )}
        </section>
    );
};
